module.exports = __webpack_public_path__ + "img/hr-green-small-grass-00.26091a65.png";